import React from "react";
import { Button } from "@mzc-pdc/ui";
import { styled } from "@mui/material";
import theme from "@styles/theme";

const StyledAiWorkspaceButton = styled(Button)({
    height: "24px",
    minWidth: 0,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    borderRadius: "100px",
    background: "linear-gradient(196deg, #8660d9 0%, #2763ea 100%)",
    color: theme.palette.common.white,
    textTransform: "none",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1.5,
    fontFamily: theme.typography.fontFamily,
    whiteSpace: "nowrap",
    "&:hover": {
        background: "linear-gradient(196deg, #8660d9 0%, #2763ea 100%)",
        opacity: 0.9,
    },
    "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.5),
    },
});

const AiWorkspaceButton = ({ startIcon, onClick, children, ...props }) => {
    return (
        <StyledAiWorkspaceButton variant="contained" startIcon={startIcon} onClick={onClick} {...props}>
            {children || "AI - Workspace"}
        </StyledAiWorkspaceButton>
    );
};

export default AiWorkspaceButton;
